import React from "react";
import { Switch, Route, Link, Redirect, useLocation } from "react-router-dom";
import "./admin.css";

import AdminDashboard from "./AdminDashboard";
import AdminStats from "./AdminStats";
import AdminAdAnalytics from "./AdminAdAnalytics";
import AdminUsers from "./AdminUsers";
import AdminGallery from "./AdminGallery";
import AdminOrders from "./AdminOrders";
import AdminShippingSettings from "./AdminShippingSettings";
import AdminPlanSettings from "./AdminPlanSettings";
import AdminRevenue from "./AdminRevenue";
import AdminReturns from "./AdminReturns";
import AdminSubscribers from "./AdminSubscribers";
import AdminContact from "./AdminContact";

export default function AdminLayout() {
  const location = useLocation();
  const isActive = (p) => location.pathname === p;

  return (
    <div className="admin-layout">
      <aside className="admin-sidebar">
        <h2>관리자</h2>

        <Link
          className={isActive("/admin") || isActive("/admin/dashboard") ? "active" : ""}
          to="/admin/dashboard"
        >
          대시보드
        </Link>

        <div className="sidebar-divider" />
        <div className="sidebar-label">서비스 관리</div>

        <Link className={isActive("/admin/users") ? "active" : ""} to="/admin/users">
          유저 관리
        </Link>
        <Link className={isActive("/admin/gallery") ? "active" : ""} to="/admin/gallery">
          갤러리 관리
        </Link>

        {/* "주문 / 출력" 묶음 통째로 메뉴에서 숨김 — 주문·취소(2026-09-15), 구독자 관리(2026-10-19 김현비, 요금제 닫음).
            라우트는 그대로라 주소로는 들어갈 수 있다. 다시 보이게 하려면 아래 주석을 풀면 된다.
        <div className="sidebar-divider" />
        <div className="sidebar-label">주문 / 출력</div>

        {/ * 메뉴에서 숨김 (2026-09-15 김현비) — 라우트(/admin/orders · /admin/returns)는
            그대로 살아 있어 주소로는 들어갈 수 있다. 다시 보이게 하려면 아래 주석만 풀면 된다.
        <Link className={isActive("/admin/orders") ? "active" : ""} to="/admin/orders">
          주문 관리
        </Link>
        <Link className={isActive("/admin/returns") ? "active" : ""} to="/admin/returns">
          취소 / 교환 / 환불
        </Link>
        * /}
        <Link className={isActive("/admin/subscribers") ? "active" : ""} to="/admin/subscribers">
          구독자 관리
        </Link>

        */}
        <div className="sidebar-divider" />
        <div className="sidebar-label">사이트 설정</div>

        <Link className={isActive("/admin/shipping-settings") ? "active" : ""} to="/admin/shipping-settings">
          배송비 설정
        </Link>
        {/* 요금제 설정 메뉴 숨김 (2026-10-19 김현비) — 요금제를 닫아 쓸 일이 없다. 라우트는 남김
        <Link className={isActive("/admin/plan-settings") ? "active" : ""} to="/admin/plan-settings">
          요금제 설정
        </Link>
        */}


        <div className="sidebar-divider" />
        <div className="sidebar-label">고객 문의</div>

        <Link className={isActive("/admin/contact") ? "active" : ""} to="/admin/contact">
          문의 관리
        </Link>

        <div className="sidebar-divider" />
        <div className="sidebar-label">분석</div>

        {/* 매출 메뉴 숨김 (2026-10-19 김현비) — 사이트 결제를 닫아 새 기록이 없다. 라우트는 남김
        <Link className={isActive("/admin/revenue") ? "active" : ""} to="/admin/revenue">
          매출
        </Link>
        */}
        <Link className={isActive("/admin/stats") ? "active" : ""} to="/admin/stats">
          통계
        </Link>
        <Link className={isActive("/admin/ad-analytics") ? "active" : ""} to="/admin/ad-analytics">
          광고 유입 분석
        </Link>
      </aside>

      <main className="admin-main">
        <Switch>
          <Route exact path="/admin" component={AdminDashboard} />
          <Route path="/admin/dashboard" component={AdminDashboard} />
          <Route path="/admin/users" component={AdminUsers} />
          <Route path="/admin/gallery" component={AdminGallery} />
          <Route path="/admin/orders" component={AdminOrders} />
          <Route path="/admin/revenue" component={AdminRevenue} />
          <Route path="/admin/stats" component={AdminStats} />
          <Route path="/admin/ad-analytics" component={AdminAdAnalytics} />
          <Route path="/admin/shipping-settings" component={AdminShippingSettings} />
          <Route path="/admin/plan-settings" component={AdminPlanSettings} />
          <Redirect exact from="/admin/quote-settings" to="/admin/dashboard" />
          <Route path="/admin/returns" component={AdminReturns} />
          <Route path="/admin/subscribers" component={AdminSubscribers} />
          <Route path="/admin/contact" component={AdminContact} />
        </Switch>
      </main>
    </div>
  );
}
